import {
  AfterContentInit,
  AfterViewInit,
  Component,
  Input,
  OnInit,
  ViewChild,
} from "@angular/core";
import {MatDialogRef as MatDialogRef } from "@angular/material/dialog";
// import { ManageMediaComponent } from "../manage-media.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { DomSanitizer } from "@angular/platform-browser";
import { SiteService as SiteManagmentService } from "src/app/new-sites-management/common/services/site.service";
import { MediaService } from "src/app/new-media/common/media.service";
import { ToastrService } from "ngx-toastr";


@Component({
  selector: "app-preview",
  templateUrl: "./preview.component.html",
  styleUrls: ["./preview.component.css"],
})
export class PreviewComponent
  implements OnInit, AfterContentInit, AfterViewInit
{
  imgHeight=500;
  blobScaledImg;
  showCropper = false;
  previousZoomVal = 0;
  @ViewChild("cropper", { static: false }) public cropper: any;
  @Input() data;
  zoomVal = 0;
  event: any;
  modalRef: BsModalRef | null;
  cropOptions = {
    viewMode: 1,
    aspectRatio: 16 / 9,
    dragMode: "crop",
    background: true,
    responsive: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
  };
  constructor(
    private dialogRef: MatDialogRef<any>,
    private _sanitizer: DomSanitizer,
    public siteManagmentService: SiteManagmentService,
    public mediaManagerService: MediaService,
    private snotifyService: ToastrService,
  ) {}
  ngAfterContentInit(): void {}

  ngOnInit() {
    
    this.scaleImage(this.data.publicUrl).then((res) => {
      this.blobScaledImg = res;
    });
  }
  ngAfterViewInit() {}
  close() {
    this.dialogRef.close();
  }

  getEditedFile(event) {
    this.modalRef.hide();
    this.event = event;
    // this.newFile();
  }

  scaleImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        var aspect = img.width / img.height;
        canvas.width = 420;
        canvas.height = 420 / aspect;
        const ctx = canvas.getContext("2d");
        this.imgHeight=(420 / aspect);
        ctx.drawImage(img, 0, 0, 420, this.imgHeight);
        canvas.toBlob(resolve);
      };
      img.onerror = reject;
      img.src = src;
    });
  }

  setScaledImageToCropper() {
    var cropperC: HTMLCollection = document.getElementsByClassName("cropper");
    var img: any = cropperC[0].firstChild;
    img.src = URL.createObjectURL(this.blobScaledImg);
  }
  rotate(angle) {
    this.cropper.cropper.rotate(angle);
  }
  changeAspectRatio(eve: any) {
    const num = eve.value;
    this.cropper.cropper.setAspectRatio(num);
  }
  flipVertically() {
    const currentScaleX = this.cropper.cropper.getData().scaleX;

    this.cropper.cropper.scaleX(-currentScaleX);
  }
  flipHorizantal() {
    const currentScaleY = this.cropper.cropper.getData().scaleY;

    this.cropper.cropper.scaleY(-currentScaleY);
  }
  disable() {
    this.cropper.cropper.disable();
  }
  reset() {
    this.cropper.cropper.reset();
    this.zoomIn(0);
    this.zoomVal = 0;
  }

  destroy() {
    this.cropper.cropper.destroy();
  }
  zoomIn(event) {
    const perZoomVal = Math.floor(event.value / 10) / 10;

    if (this.previousZoomVal < perZoomVal) {
      this.cropper.cropper.zoom(perZoomVal - this.previousZoomVal);
    } else if (this.previousZoomVal > perZoomVal) {
      this.cropper.cropper.zoom(-(this.previousZoomVal - perZoomVal));
    }
    this.previousZoomVal = perZoomVal;
  }
  formatLabel(value: number): string {
    return `${value}`;
  }
  crop() {
    this.cropper.cropper.getCroppedCanvas().toBlob((blob) => {
      var formData = new FormData();
      formData.append("CultureId", this.data.cultureId);
      if (this.data.folderId) {
        formData.append("ParentId", this.data.folderId.toString());
      }
      formData.append("Uploads", blob, this.data.filename);
      var selectedFolderId;
      this.mediaManagerService.saveMedia(formData).subscribe((res) => {
        this.mediaManagerService.media$.subscribe();
        this.mediaManagerService.media$.subscribe((res: any) => {
          selectedFolderId = res.currentFolderId;
        });

        //to do
        formData.append("ConvertToWebp", "true");

        this.mediaManagerService
          .searchMediaAndFolders(selectedFolderId)
          .subscribe((res: any) => {
            this.mediaManagerService.isParentIdChanged(
              res.currentFolderId,
              res.currentFolderName,
              res.parentFolderId,
              res.itemCount,
              res.currentFolderBreadcrumb
            );
              this.snotifyService.success("","Image Saved Successfully !" , {
                timeOut: 2000,
                progressBar: true,
                tapToDismiss: true,
              });
          
          });
          this.mediaManagerService.getAllSideFolders();
          
      });
    }, "image/png");
  }
  activateCropper() {
    this.showCropper = true;
    setTimeout(() => {
      this.setScaledImageToCropper();
    }, 1);
  }
}
